// import React, { useEffect, useState } from 'react';
// import { toast } from 'react-toastify';

// import { useLocation, useNavigate } from 'react-router-dom';
// import {
//     Table, Button, Form, FormGroup, Label, Input, Card, CardBody, CardTitle
//     , Row, Col
// } from 'reactstrap';
// import { apiService } from '../../constants/ApiService';
// import Loader from '../../layouts/loader/Loader';
// import { validate } from 'uuid';
// import { useSelector } from 'react-redux';

// import Autocomplete from '@mui/material/Autocomplete';
// import TextField from '@mui/material/TextField';
// import { prefetchDNS } from 'react-dom';
// import { fabClasses } from '@mui/material';
// import ErrorModal from '../../constants/ErrorModal';
// import SpinnerLoader from '../../constants/SpinnerLoader';



// const AddUserMaster = () => {

//     const [userDetail, setUserDetail] = useState({
//         // user_code: "",
//         user_profile_id: "",
//         user_name: "",
//         user_mobile: "",
//         user_email: "",
//         user_pass: "",
//         user_status: "ACTIVE",

//         branch_id_and_names: "0-0",
//         sub_branch_id_and_names: "0-0",
//         vender_master_id: null

//         // save_yes_no: "yes",
//         // modify_yes_no: "yes",
//         // delete_yes_no: "yes",
//         // cs_save_yes_no: "yes",
//         // cs_modi_del_yes_no: "yes",
//         // print_only: "yes",
//         // user_mobile: "",
//         // user_email: "",
//         // user_email_pass: "",
//         // user_created_on: "",
//         // user_updated_on: "",
//         // software_version: "",
//         // user_allotement_status: "",
//         // report_yes_no: "yes",
//         // comp_id: "",
//         // comp_name: "",
//         // view_yes_no: "",
//         // user_profile_id: "",
//         // user_pancard: "",
//         // user_email_verified_yn: "",
//         // user_phn_verified_yn: "",
//         // user_pan_verified_yn: "",
//         // user_creation_mode: "",
//         // user_created_by_name: "",
//         // user_created_by_id: "",
//         // sponsored_user_id: "",
//         // sponsored_user_mobile: "",
//         // left_side_user_id: "",
//         // right_side_user_id: "",
//         // left_side_user_mobile: "",
//         // right_side_user_mobile: "",
//         // under_user_id: "",
//         // under_user_mobile: "",
//         // sponsored_by_user_name: "",
//         // branch_id: "",
//         // branch_view_all: "yes",
//     });
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [editMode, setEditMode] = useState(false)
//     const [hidePassword, setHidePassword] = useState(false);

//     const [loading, setLoading] = useState(false);
//     const [errors, setErrors] = useState({});
//     const [userProfileList, setUserProfileList] = useState([]);

//     const [branchMaster, setBranchMasterTable] = useState([]);
//     const [venderMaster, setVenderMasterTable] = useState([]);
//     const { user } = useSelector((state) => state.authState);
//     const [selectMultipleBranch, setSelectMultipleBranch] = useState(["0-All"]);
//     const [pageloading, setPageLoading] = useState({
//         vender: true,
//         branch: true,
//         user_profile: true,
//     });
//     const [showErrorModal, setShowErrorModal] = useState(false)
//     const [isSubmitting, setIsSubmitting] = useState(false);



//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         if (name === "vender_master_id") {

//             setSelectMultipleBranch(["0-All"])
//             setUserDetail({ ...userDetail, [name]: value });

//         } else {
//             setUserDetail({ ...userDetail, [name]: value });
//         }

//     };


//     const onHandleBack = () => {
//         navigate(-1)
//     };

//     const getuserProfile = async () => {
//         try {
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             const response = await apiService.get(`api/admin/User_Detail/GetUserProfile`, config)
//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 setUserProfileList(response.user_Profile_Masters)
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         } finally {
//             setPageLoading(prev => ({ ...prev, user_profile: false }));
//         }
//     }


//     useEffect(() => {
//         // getuserProfile()
//     }, [])

//     const validate = () => {
//         let formErrors = {};


//         if (!userDetail.vender_master_id) {
//             formErrors.vender_master_id = "Vender Name is required.";
//         }

//         // if (!userDetail.branch_master_id) {
//         //     formErrors.branch_master_id = "Branch Name is required.";
//         // }


//         if (!userDetail.user_profile_id) {
//             formErrors.user_profile_id = "User Profile is required.";
//         }

//         if (!userDetail.user_name) {
//             formErrors.user_name = "User Name is required.";
//         } else if (userDetail.user_name.length < 3) {
//             formErrors.user_name = "User Name must be at least 3 characters long.";
//         }

//         if (!userDetail.user_pass) {
//             formErrors.user_pass = "Password is required.";
//         } else if (userDetail.user_pass.length < 6) {
//             formErrors.user_pass = "Password must be at least 6 characters long.";
//         }

//         if (!userDetail.user_mobile) {
//             formErrors.user_mobile = "Mobile number is required.";
//         } else if (!/^\d{10}$/.test(userDetail.user_mobile)) {
//             formErrors.user_mobile = "Mobile number must be 10 digits.";
//         }

//         if (!userDetail.user_email) {
//             formErrors.user_email = "Email is required.";
//         } else if (!/\S+@\S+\.\S+/.test(userDetail.user_email)) {
//             formErrors.user_email = "Invalid email format.";
//         }

//         // if (!userDetail.user_email_pass) {
//         //     formErrors.user_email_pass = "Email Password is required.";
//         // }

//         if (!userDetail.user_status) {
//             formErrors.user_status = "User Status is required.";
//         }

//         console.log(formErrors, "formErrorsformErrorsformErrors", userDetail);

//         setErrors(formErrors);
//         return Object.keys(formErrors).length === 0;
//     };


//     const handleSubmit = async () => {

//         // If already submitting, do nothing
//         if (isSubmitting) {
//             return;
//         }

//         setIsSubmitting(true);

//         let validation = validate()
//         if (!validation) {
//             setShowErrorModal(true);
//             setIsSubmitting(false);
//             return
//         }


//         try {

//             setLoading(true)
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             let params = {
//                 ...userDetail,
//                 confirm_user_pass: userDetail.user_pass,
//                 sponsored_user_mobile: userDetail.user_pass,
//                 branch_id_and_names: selectMultipleBranch.join(','),
//                 // working_bussinesss_mode: venderMaster.find(data => data.id === userDetail.vender_master_id)?.working_bussinesss_mode
//             }


            

//             const response = await apiService.post(`api/admin/User_Detail/branch/CreateUser`, params, config)
//             setLoading(false)

//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 toast.success(response.message);
//                 navigate('/user');
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         }
//         finally {
//             setIsSubmitting(false); // Re-enable button
//         }
//     }

//     const getUserDetail = async (userId) => {
//         try {
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             const response = await apiService.get(`api/admin/User_Detail/GetUserById?Id=${userId}`, config)
//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 let { branch_id_and_names } = response.user_Detail;
//                 if (branch_id_and_names) {
//                     const result = branch_id_and_names.split(',')
//                     setSelectMultipleBranch(result)
//                 } else {
//                     setSelectMultipleBranch([])
//                 }
//                 setUserDetail(response.user_Detail);
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         }
//     };

//     const UpdateUserDetail = async () => {

//         // If already submitting, do nothing
//         if (isSubmitting) {
//             return;
//         }

//         setIsSubmitting(true);

//         let validation = validate()
//         if (!validation) {
//             setShowErrorModal(true);
//             setIsSubmitting(false);

//             return
//         }


//         try {

//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json',
//                     'Id': userDetail.id, // Add the Id in the header
//                 }
//             };
//             setLoading(true)


//             let params = {
//                 ...userDetail,
//                 // confirm_user_pass: userDetail.user_pass,
//                 sponsored_user_mobile: userDetail.user_pass,
//                 branch_id_and_names: selectMultipleBranch.join(','),
//                // working_bussinesss_mode: venderMaster.find(data => data.id === userDetail.vender_master_id)?.working_bussinesss_mode

//             }

//             // Conditionally add passwords to params if hidePassword is false
//             if (!hidePassword) {
//                 params.user_pass = userDetail.user_pass;
//                 // params.confirm_user_pass = userDetail.user_pass;
//             } else {
//                 // Optionally remove these keys if they exist in userDetail and you don't want to send them
//                 delete params.user_pass;
//                 // delete params.confirm_user_pass;
//             }

//             const response = await apiService.post(`api/admin/User_Detail/Edit_User`, params, config)

//             if (response === "success") {
//                 toast.success("Updated Successfully");
//             }

//             // if (response.response && response.response.data.errors) {
//             //     toast.error(response.response?.data?.errors);
//             // }

//             // if (response.status === true) {
//             //     alert(response.message)
//             //     // setPortfolioData(initial)
//             // }
//             // else {
//             //     toast.success(response.message);
//             // }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         }
//         finally {
//             setLoading(false)
//             setIsSubmitting(false); // Re-enable button

//         }

//     }

//     const getBranchVendorName = async (page = 1, limit = 10, search = "") => {
//         try {
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             const response = await apiService.get(`api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 // console.log(response.CompanyMasterMasterData)
//                 if (response.venderMasterData.length === 1 && response.venderMasterData) {

//                     setVenderMasterTable(response.venderMasterData)
//                     setUserDetail((prevDetails) => ({
//                         ...prevDetails,
//                         vender_master_id: response.venderMasterData[0].id,
//                     }));

//                 } else {
//                     setVenderMasterTable(response.venderMasterData)
//                 }
//                 // toast.success(response.message);
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         } finally {
//             setPageLoading(prev => ({ ...prev, vender: false }));
//         }
//     };

//     const getBranchMasterData = async (page = 1, limit = 10, search = "") => {
//         try {
//             let config = {
//                 headers: {
//                     'Content-Type': 'application/json', // Important for file upload//s
//                     'accept': 'application/json'
//                 }
//             };

//             const filterName = user.user_profile !== "hotel" ? userDetail.vender_master_id : null;

//             let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
//             if (filterName) {
//                 queryString += `&filterName=${filterName}`;
//             }


//             const response = await apiService.get(`api/BranchMaster/all?${queryString}`, config);
//             if (response.response && response.response.data.errors) {
//                 toast.error(response.response?.data?.errors);
//             }

//             if (response.status === true) {
//                 // console.log(response.BranchMasterMasterData)
//                 // setBranchMasterTable(response.branchMasterData)


//                 if (response.branchMasterData.length === 1 && response.branchMasterData) {

//                     setBranchMasterTable(response.branchMasterData)
//                     // setPartyData((prevDetails) => ({
//                     //     ...prevDetails,
//                     //     party_branch_master_id: response.branchMasterData[0].id,
//                     // }));

//                 } else {
//                     setBranchMasterTable(response.branchMasterData)
//                 }

//                 // toast.success(response.message);
//             }
//             else {
//                 toast.success(response.message);
//             }
//         } catch (error) {
//             console.log(error)
//             toast.error(`SomeThing went wrong!!`);
//         } finally {
//             setPageLoading(prev => ({ ...prev, branch: false }));
//         }
//     };

//     useEffect(() => {
//         getBranchVendorName()
//         if (user.user_profile != "hotel" && userDetail?.vender_master_id) {
//             getBranchMasterData()
//         } else {
//             getBranchMasterData()
//         }
//     }, [userDetail?.vender_master_id])


//     useEffect(() => {
//         if (location.state) {
//             getUserDetail(location.state.userId)
//             setEditMode(true)
//             setHidePassword(true);
//         }
//         getuserProfile()
//     }, [location.state])

//     // Function to reset the password field
//     const resetPassword = () => {
//         setUserDetail((prevState) => ({
//             ...prevState, // Spread the previous state to keep other properties
//             user_pass: '', // Reset the password field to an empty string
//         }));
//         setHidePassword(false);
//     };


//     const goTODeleteModel = (id) => {
//         const currentUrl = `${window.location.origin}`;
//         const url = `${currentUrl}/commonDelete?itemId=${id}&flag=user_profile`;
//         window.open(url, '_blank');

//         setTimeout(() => {
//             window.close();
//         }, 1000);
//     };




//     useEffect(() => {

//         const allApisLoaded = Object.values(loading).every(status => status === false);

//         if (!allApisLoaded) return;

//         const newErrors = {};

//         if (!venderMaster || venderMaster.length === 0) {
//             newErrors.vender_master_id = 'Vender is required.';
//         }

//         // if (!branchMaster || branchMaster.length === 0) {
//         //     newErrors.branch_master_id = 'Branch is required.';
//         // }

//         if (!userProfileList || userProfileList.length === 0) {
//             newErrors.user_profile_id = 'User Profile is required.';
//         }

//         if (Object.keys(newErrors).length > 0) {
//             setErrors(newErrors);
//             setShowErrorModal(true);
//         } else {
//             setErrors({});
//             setShowErrorModal(false);
//         }
//     }, [venderMaster, userProfileList, loading]);  //branchMaster, 

//     if (Object.values(pageloading).some(status => status === true)) {
//         return <SpinnerLoader />
//     }





//     return (
//         <Row>
//             <Col>
//                 <Card className='bg-white pd-10 card-box mb-30'>
//                     <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
//                         {editMode ?
//                             <div className="d-flex align-items-center">
//                                 <i className="bi bi-bell mr-2"></i>
//                                 Edit User Detail
//                             </div>
//                             :
//                             <div className="d-flex align-items-center">
//                                 <i className="bi bi-bell mr-2"></i>
//                                 Add User Detail
//                             </div>
//                         }
//                         <Button color="warning" size="bg" onClick={onHandleBack} className="ml-auto">
//                             Back
//                         </Button>

//                         {
//                             editMode && (
//                                 <>
//                                     <td>
//                                         <Button color="danger" size="bg" className='ms-2' onClick={() => goTODeleteModel(userDetail.id)}>
//                                             Delete
//                                         </Button>
//                                     </td>
//                                 </>
//                             )
//                         }

//                     </CardTitle>

//                     <CardBody>
//                         <Form className="container mt-4">

//                             <Row>

//                                 {/* <Col xl={4}>

//                                     <FormGroup>
//                                         <Label for="user_code">USER CODE</Label>
//                                         <Input   type="number" id="user_code" name="user_code" value={userDetail.user_code} onChange={handleChange} />
//                                     </FormGroup>
//                                 </Col> */}
//                                 <Col xl={6}>

//                                     {<FormGroup>
//                                         <Label for="vender_master_id">Vendor Name</Label>
//                                         <Input 
//                                             type='select'  className="custom-select"
//                                             id="vender_master_id"
//                                             name="vender_master_id"
//                                             value={userDetail.vender_master_id}
//                                             onChange={handleChange}
//                                         >
//                                             <option value="">Select</option>
//                                             {venderMaster.map((option) => (
//                                                 <option key={option.id} value={option.id} data-id={option.id}>
//                                                     {option.vender_name}
//                                                 </option>
//                                             ))}
//                                         </Input>
//                                         {errors.vender_master_id && <p className="text-danger">{errors.vender_master_id}</p>}

//                                     </FormGroup>}
//                                 </Col>

//                                 <Col xl={6}>

//                                     <FormGroup>
//                                         <Label for="sub_branch_id_and_names">Branch Name</Label>
//                                         <Autocomplete
                                            
//                                             size="small"
//                                             multiple
//                                             options={[{ id: 0, branch_name: "All" }, ...branchMaster]}
//                                             getOptionLabel={(option) => `${option.id}-${option.branch_name}`}
//                                             value={selectMultipleBranch.map(value =>
//                                                 typeof value === "string" ? { id: parseInt(value.split('-')[0]), branch_name: value.split('-')[1] } : value
//                                             )}
//                                             onChange={(event, newValue) => {
//                                                 // Remove "0-All" from the selected values if present
//                                                 let updatedValues = newValue
//                                                     .map(item => `${item.id}-${item.branch_name}`)
//                                                     .filter(item => item !== "0-All");

//                                                 // If no hotels are selected, add "0-All" back to the list
//                                                 if (updatedValues.length === 0) {
//                                                     updatedValues = ["0-All"];
//                                                 }

//                                                 setSelectMultipleBranch(updatedValues);
//                                             }}
//                                             renderInput={(params) => <TextField {...params} placeholder="Select Branchs" />}
//                                             isOptionEqualToValue={(option, value) => {
//                                                 if (typeof value === "string") {
//                                                     return option.id === parseInt(value.split('-')[0]);
//                                                 }
//                                                 return option.id === value.id;
//                                             }}
//                                         />
//                                     </FormGroup>

//                                 </Col>

//                                 <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_profile_id">USER PROFILE</Label>
//                                         <Input  type="select"  className="custom-select" id="user_profile_id"
//                                             name="user_profile_id"
//                                             value={userDetail.user_profile_id}
//                                             onChange={handleChange}
//                                         >
//                                             <option value="">Select State</option>
//                                             {
//                                                 userProfileList.map((data) => (
//                                                     <option value={data.id}>{data.user_profile}</option>
//                                                 ))
//                                             }
//                                         </Input>
//                                     </FormGroup>
//                                     {errors.user_profile_id && <p className="text-danger">{errors.user_profile_id}</p>}

//                                 </Col>
//                                 <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_name">USER NAME</Label>
//                                         <Input  type="text" id="user_name" name="user_name" value={userDetail.user_name} onChange={handleChange} />
//                                     </FormGroup>
//                                     {errors.user_name && <p className="text-danger">{errors.user_name}</p>}

//                                 </Col>


//                                 <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_pass">
//                                             USER PASSWORD
//                                             {editMode && <i
//                                                 className={`fa fa-refresh position-absolute  reset_password_icon`} // Add the 'clicked' class if clicked
                                             
//                                                 onClick={resetPassword} // OnClick event to reset password
//                                             ></i>}
//                                         </Label>
//                                         <Input  type={hidePassword ? "password" : "text"} id="user_pass"
//                                             name="user_pass" value={userDetail.user_pass} onChange={handleChange} disabled={hidePassword} />
//                                     </FormGroup>
//                                     {errors.user_pass && <p className="text-danger">{errors.user_pass}</p>}
//                                 </Col>

//                                 <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_mobile">USER MOBILE</Label>
//                                         <Input  type="number" id="user_mobile" name="user_mobile" value={userDetail.user_mobile} onChange={handleChange}
//                                             disabled={editMode} />
//                                     </FormGroup>
//                                     {errors.user_mobile && <p className="text-danger">{errors.user_mobile}</p>}

//                                 </Col>
//                                 <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_email">USER EMAIL</Label>
//                                         <Input  type="email" id="user_email" name="user_email" value={userDetail.user_email} onChange={handleChange} />
//                                     </FormGroup>
//                                     {errors.user_email && <p className="text-danger">{errors.user_email}</p>}

//                                 </Col>
//                                 {/* <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_email_pass">USER EMAIL PASSWORD</Label>
//                                         <Input  
//                                             type="password"
//                                             id="user_email_pass"
//                                             name="user_email_pass"
//                                             value={userDetail.user_email_pass}
//                                             onChange={handleChange}
//                                         />
//                                     </FormGroup>
//                                 </Col> */}
//                                 <Col xl={4}>
//                                     <FormGroup>
//                                         <Label for="user_status">USER STATUS</Label>
//                                         <Input  type="select"  className="custom-select" id="user_status"
//                                             name="user_status"
//                                             value={userDetail.user_status}
//                                             onChange={handleChange}
                                            
//                                         >
//                                             <option value="">Select</option>
//                                             <option value="ACTIVE">Active</option>
//                                             <option value="INACTIVE">Inactive</option>

//                                         </Input>
//                                         {errors.user_status && <p className="text-danger">{errors.user_status}</p>}

//                                     </FormGroup>
//                                 </Col>
//                             </Row>


//                             {editMode ?
//                                 <Button type="button" color="primary" disabled={isSubmitting}
//                                     onClick={UpdateUserDetail}>
//                                     {loading ? <Loader /> : "Update"}
//                                 </Button>
//                                 : <Button type="button" color="primary" disabled={isSubmitting}
//                                     onClick={handleSubmit}>
//                                     {loading ? <Loader /> : "Save"}
//                                 </Button>}
//                         </Form>

//                     </CardBody>


//                     {/* Error Model */}

//                     <ErrorModal
//                         show={showErrorModal}
//                         title="Validation / Action Required"
//                         content={errors}
//                         condition={true}
//                         onCancel={() => setShowErrorModal(false)}
//                     // onConfirm={true}
//                     />

//                 </Card>
//             </Col>
//         </Row>
//     )
// }


// export default AddUserMaster
//heena
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useLocation, useNavigate } from 'react-router-dom';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
} from 'reactstrap';

import { apiService } from '../../constants/ApiService';
import Loader from '../../layouts/loader/Loader';
import { useSelector } from 'react-redux';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';

const AddUserMaster = () => {
  const [userDetail, setUserDetail] = useState({
    user_profile_id: '',
    user_name: '',
    user_mobile: '',
    user_email: '',
    user_pass: '',
    user_status: 'ACTIVE',

    branch_id_and_names: '0-0',
    sub_branch_id_and_names: '0-0',
    vender_master_id: null,

    // Salary Definition
    salary_definition_id: '',
    salary_amount: '',
    designation: '',
    leave_allowed: '',
  });

  const navigate = useNavigate();
  const location = useLocation();

  const [editMode, setEditMode] = useState(false);
  const [hidePassword, setHidePassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [userProfileList, setUserProfileList] = useState([]);

  const [branchMaster, setBranchMasterTable] = useState([]);
  const [venderMaster, setVenderMasterTable] = useState([]);
  const [salaryDefinitionList, setSalaryDefinitionList] = useState([]);

  const { user } = useSelector((state) => state.authState);

  const [selectMultipleBranch, setSelectMultipleBranch] = useState(['0-All']);

  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
    user_profile: true,
  });

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'vender_master_id') {
      setSelectMultipleBranch(['0-All']);
      setSalaryDefinitionList([]);

      setUserDetail((prev) => ({
        ...prev,
        vender_master_id: value,
        salary_definition_id: '',
        salary_amount: '',
        designation: '',
        leave_allowed: '',
      }));

      return;
    }

    setUserDetail((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSalaryDefinitionChange = (e) => {
    const selectedId = e.target.value;

    if (!selectedId) {
      setUserDetail((prev) => ({
        ...prev,
        salary_definition_id: '',
        salary_amount: '',
        designation: '',
        leave_allowed: '',
      }));
      return;
    }

    const selected = salaryDefinitionList.find(
      (x) => String(x.id) === String(selectedId),
    );

    setUserDetail((prev) => ({
      ...prev,
      salary_definition_id: selected?.id || '',
      salary_amount: selected?.salary || '',
      designation: selected?.designation || '',
      leave_allowed: selected?.leave_allowed || '',
    }));
  };

  const onHandleBack = () => {
    navigate(-1);
  };

  const getuserProfile = async () => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/admin/User_Detail/GetUserProfile`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setUserProfileList(response.user_Profile_Masters || []);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, user_profile: false }));
    }
  };

  const validate = () => {
    const formErrors = {};

    if (!userDetail.vender_master_id) {
      formErrors.vender_master_id = 'Vender Name is required.';
    }

    if (!userDetail.user_profile_id) {
      formErrors.user_profile_id = 'User Profile is required.';
    }

    // if (!userDetail.salary_definition_id) {
    //   formErrors.salary_definition_id = 'Designation is required.';
    // }

    if (!userDetail.user_name) {
      formErrors.user_name = 'User Name is required.';
    } else if (userDetail.user_name.length < 3) {
      formErrors.user_name = 'User Name must be at least 3 characters long.';
    }

    if (!editMode) {
      if (!userDetail.user_pass) {
        formErrors.user_pass = 'Password is required.';
      } else if (userDetail.user_pass.length < 6) {
        formErrors.user_pass = 'Password must be at least 6 characters long.';
      }
    } else if (!hidePassword && userDetail.user_pass && userDetail.user_pass.length < 6) {
      formErrors.user_pass = 'Password must be at least 6 characters long.';
    }

    if (!userDetail.user_mobile) {
      formErrors.user_mobile = 'Mobile number is required.';
    } else if (!/^\d{10}$/.test(userDetail.user_mobile)) {
      formErrors.user_mobile = 'Mobile number must be 10 digits.';
    }

    if (!userDetail.user_email) {
      formErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(userDetail.user_email)) {
      formErrors.user_email = 'Invalid email format.';
    }

    if (!userDetail.user_status) {
      formErrors.user_status = 'User Status is required.';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    const validation = validate();

    if (!validation) {
      setShowErrorModal(true);
      setIsSubmitting(false);
      return;
    }

    try {
      setLoading(true);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const params = {
        ...userDetail,
        confirm_user_pass: userDetail.user_pass,
        sponsored_user_mobile: userDetail.user_pass,
        branch_id_and_names: selectMultipleBranch.join(','),

        salary_definition_id: userDetail.salary_definition_id
          ? Number(userDetail.salary_definition_id)
          : null,

        salary_amount:
          userDetail.salary_amount === '' || userDetail.salary_amount === null
            ? null
            : Number(userDetail.salary_amount),
      };

      const response = await apiService.post(
        `api/admin/User_Detail/branch/CreateUser`,
        params,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        navigate('/user');
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const getUserDetail = async (userId) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/admin/User_Detail/GetUserById?Id=${userId}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        const data = response.user_Detail || {};

        const { branch_id_and_names } = data;

        if (branch_id_and_names) {
          const result = branch_id_and_names.split(',');
          setSelectMultipleBranch(result);
        } else {
          setSelectMultipleBranch([]);
        }

        setUserDetail((prev) => ({
          ...prev,
          ...data,
          salary_definition_id: data.salary_definition_id || '',
          salary_amount: data.salary_amount || '',
          designation: data.designation || '',
          leave_allowed: data.leave_allowed || '',
        }));
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const UpdateUserDetail = async () => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    const validation = validate();

    if (!validation) {
      setShowErrorModal(true);
      setIsSubmitting(false);
      return;
    }

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          Id: userDetail.id,
        },
      };

      setLoading(true);

      const params = {
        ...userDetail,
        sponsored_user_mobile: userDetail.user_pass,
        branch_id_and_names: selectMultipleBranch.join(','),

        salary_definition_id: userDetail.salary_definition_id
          ? Number(userDetail.salary_definition_id)
          : null,

        salary_amount:
          userDetail.salary_amount === '' || userDetail.salary_amount === null
            ? null
            : Number(userDetail.salary_amount),
      };

      if (!hidePassword) {
        params.user_pass = userDetail.user_pass;
      } else {
        delete params.user_pass;
      }

      const response = await apiService.post(
        `api/admin/User_Detail/Edit_User`,
        params,
        config,
      );

      if (response === 'success') {
        toast.success('Updated Successfully');
        navigate('/user');
      } else if (response?.status === false) {
        toast.error(response?.message || response?.Message || 'Update failed');
      } else {
        toast.success('Updated Successfully');
        navigate('/user');
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const getBranchVendorName = async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        if (response.venderMasterData.length === 1 && response.venderMasterData) {
          setVenderMasterTable(response.venderMasterData);

          setUserDetail((prevDetails) => ({
            ...prevDetails,
            vender_master_id: response.venderMasterData[0].id,
          }));
        } else {
          setVenderMasterTable(response.venderMasterData || []);
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, vender: false }));
    }
  };

  const getBranchMasterData = async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const filterName =
        user.user_profile !== 'hotel' ? userDetail.vender_master_id : null;

      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;

      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }

      const response = await apiService.get(
        `api/BranchMaster/all?${queryString}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setBranchMasterTable(response.branchMasterData || []);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, branch: false }));
    }
  };

  const getSalaryDefinitionList = async () => {
    try {
      const vendorId = userDetail.vender_master_id || '';

      const selectedBranchId =
        selectMultipleBranch && selectMultipleBranch.length > 0
          ? String(selectMultipleBranch[0]).split('-')[0]
          : '';

      if (!vendorId || !selectedBranchId || selectedBranchId === '0') {
        setSalaryDefinitionList([]);
        return;
      }

      const response = await apiService.get(
        `api/SalaryDefinition/GetAllSalaryDefinition?vendorId=${vendorId}&branchId=${selectedBranchId}`,
      );

      console.log('GET SALARY DEFINITION RESPONSE:', response);

      if (response?.status === true) {
        setSalaryDefinitionList(response.data || response.Data || []);
      } else {
        setSalaryDefinitionList([]);
        toast.error(
          response?.message ||
            response?.Message ||
            'Salary definition not found',
        );
      }
    } catch (error) {
      console.log(error);
      setSalaryDefinitionList([]);
      toast.error('Failed to load salary definition');
    }
  };

  useEffect(() => {
    getBranchVendorName();

    if (user.user_profile !== 'hotel' && userDetail?.vender_master_id) {
      getBranchMasterData();
    } else {
      getBranchMasterData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetail?.vender_master_id]);

  useEffect(() => {
    getSalaryDefinitionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetail.vender_master_id, selectMultipleBranch]);

  useEffect(() => {
    if (location.state) {
      getUserDetail(location.state.userId);
      setEditMode(true);
      setHidePassword(true);
    }

    getuserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const resetPassword = () => {
    setUserDetail((prevState) => ({
      ...prevState,
      user_pass: '',
    }));

    setHidePassword(false);
  };

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=user_profile`;
    window.open(url, '_blank');

    setTimeout(() => {
      window.close();
    }, 1000);
  };

  useEffect(() => {
    const allApisLoaded = Object.values(pageloading).every(
      (status) => status === false,
    );

    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.vender_master_id = 'Vender is required.';
    }

    if (!userProfileList || userProfileList.length === 0) {
      newErrors.user_profile_id = 'User Profile is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setShowErrorModal(true);
    } else {
      setErrors({});
      setShowErrorModal(false);
    }
  }, [venderMaster, userProfileList, pageloading]);

  if (Object.values(pageloading).some((status) => status === true)) {
    return <SpinnerLoader />;
  }

  return (
    <Row>
      <Col>
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            {editMode ? (
              <div className='d-flex align-items-center'>
                <i className='bi bi-bell mr-2'></i>
                Edit User Detail
              </div>
            ) : (
              <div className='d-flex align-items-center'>
                <i className='bi bi-bell mr-2'></i>
                Add User Detail
              </div>
            )}

            <Button
              color='warning'
              size='bg'
              onClick={onHandleBack}
              className='ml-auto'
            >
              Back
            </Button>

            {editMode && (
              <Button
                color='danger'
                size='bg'
                className='ms-2'
                onClick={() => goTODeleteModel(userDetail.id)}
              >
                Delete
              </Button>
            )}
          </CardTitle>

          <CardBody>
            <Form className='container mt-4'>
              <Row>
                <Col xl={6}>
                  <FormGroup>
                    <Label for='vender_master_id'>Vendor Name</Label>
                    <Input
                      type='select'
                      className='custom-select'
                      id='vender_master_id'
                      name='vender_master_id'
                      value={userDetail.vender_master_id || ''}
                      onChange={handleChange}
                    >
                      <option value=''>Select</option>
                      {venderMaster.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-id={option.id}
                        >
                          {option.vender_name}
                        </option>
                      ))}
                    </Input>

                    {errors.vender_master_id && (
                      <p className='text-danger'>{errors.vender_master_id}</p>
                    )}
                  </FormGroup>
                </Col>

                <Col xl={6}>
                  <FormGroup>
                    <Label for='sub_branch_id_and_names'>Branch Name</Label>
                    <Autocomplete
                      size='small'
                      multiple
                      options={[{ id: 0, branch_name: 'All' }, ...branchMaster]}
                      getOptionLabel={(option) =>
                        `${option.id}-${option.branch_name}`
                      }
                      value={selectMultipleBranch.map((value) =>
                        typeof value === 'string'
                          ? {
                              id: parseInt(value.split('-')[0]),
                              branch_name: value.split('-')[1],
                            }
                          : value,
                      )}
                      onChange={(event, newValue) => {
                        let updatedValues = newValue
                          .map((item) => `${item.id}-${item.branch_name}`)
                          .filter((item) => item !== '0-All');

                        if (updatedValues.length === 0) {
                          updatedValues = ['0-All'];
                        }

                        setSelectMultipleBranch(updatedValues);

                        setUserDetail((prev) => ({
                          ...prev,
                          salary_definition_id: '',
                          salary_amount: '',
                          designation: '',
                          leave_allowed: '',
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder='Select Branchs' />
                      )}
                      isOptionEqualToValue={(option, value) => {
                        if (typeof value === 'string') {
                          return option.id === parseInt(value.split('-')[0]);
                        }

                        return option.id === value.id;
                      }}
                    />
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='user_profile_id'>USER PROFILE</Label>
                    <Input
                      type='select'
                      className='custom-select'
                      id='user_profile_id'
                      name='user_profile_id'
                      value={userDetail.user_profile_id || ''}
                      onChange={handleChange}
                    >
                      <option value=''>Select State</option>
                      {userProfileList.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.user_profile}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  {errors.user_profile_id && (
                    <p className='text-danger'>{errors.user_profile_id}</p>
                  )}
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='salary_definition_id'>Designation</Label>
                    <Input
                      type='select'
                      className='custom-select'
                      id='salary_definition_id'
                      name='salary_definition_id'
                      value={userDetail.salary_definition_id || ''}
                      onChange={handleSalaryDefinitionChange}
                    >
                      <option value=''>Select Designation</option>
                      {salaryDefinitionList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.designation}
                        </option>
                      ))}
                    </Input>

                    {errors.salary_definition_id && (
                      <p className='text-danger'>
                        {errors.salary_definition_id}
                      </p>
                    )}
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='salary_amount'>Salary Amount</Label>
                    <Input
                      type='number'
                      id='salary_amount'
                      name='salary_amount'
                      value={userDetail.salary_amount || ''}
                      onChange={handleChange}
                      min='0'
                      step='0.01'
                      placeholder='Salary Amount'
                    />
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='leave_allowed'>Leave Allowed</Label>
                    <Input
                      type='number'
                      id='leave_allowed'
                      name='leave_allowed'
                      value={userDetail.leave_allowed || ''}
                      readOnly
                      placeholder='Leave Allowed'
                    />
                  </FormGroup>
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='user_name'>USER NAME</Label>
                    <Input
                      type='text'
                      id='user_name'
                      name='user_name'
                      value={userDetail.user_name || ''}
                      onChange={handleChange}
                    />
                  </FormGroup>

                  {errors.user_name && (
                    <p className='text-danger'>{errors.user_name}</p>
                  )}
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='user_pass'>
                      USER PASSWORD
                      {editMode && (
                        <i
                          className='fa fa-refresh position-absolute reset_password_icon'
                          onClick={resetPassword}
                        ></i>
                      )}
                    </Label>

                    <Input
                      type={hidePassword ? 'password' : 'text'}
                      id='user_pass'
                      name='user_pass'
                      value={userDetail.user_pass || ''}
                      onChange={handleChange}
                      disabled={hidePassword}
                    />
                  </FormGroup>

                  {errors.user_pass && (
                    <p className='text-danger'>{errors.user_pass}</p>
                  )}
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='user_mobile'>USER MOBILE</Label>
                    <Input
                      type='number'
                      id='user_mobile'
                      name='user_mobile'
                      value={userDetail.user_mobile || ''}
                      onChange={handleChange}
                      disabled={editMode}
                    />
                  </FormGroup>

                  {errors.user_mobile && (
                    <p className='text-danger'>{errors.user_mobile}</p>
                  )}
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='user_email'>USER EMAIL</Label>
                    <Input
                      type='email'
                      id='user_email'
                      name='user_email'
                      value={userDetail.user_email || ''}
                      onChange={handleChange}
                    />
                  </FormGroup>

                  {errors.user_email && (
                    <p className='text-danger'>{errors.user_email}</p>
                  )}
                </Col>

                <Col xl={4}>
                  <FormGroup>
                    <Label for='user_status'>USER STATUS</Label>
                    <Input
                      type='select'
                      className='custom-select'
                      id='user_status'
                      name='user_status'
                      value={userDetail.user_status || ''}
                      onChange={handleChange}
                    >
                      <option value=''>Select</option>
                      <option value='ACTIVE'>Active</option>
                      <option value='INACTIVE'>Inactive</option>
                    </Input>

                    {errors.user_status && (
                      <p className='text-danger'>{errors.user_status}</p>
                    )}
                  </FormGroup>
                </Col>
              </Row>

              {editMode ? (
                <Button
                  type='button'
                  color='primary'
                  disabled={isSubmitting}
                  onClick={UpdateUserDetail}
                >
                  {loading ? <Loader /> : 'Update'}
                </Button>
              ) : (
                <Button
                  type='button'
                  color='primary'
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                >
                  {loading ? <Loader /> : 'Save'}
                </Button>
              )}
            </Form>
          </CardBody>

          <ErrorModal
            show={showErrorModal}
            title='Validation / Action Required'
            content={errors}
            condition={true}
            onCancel={() => setShowErrorModal(false)}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default AddUserMaster;
